// extracted by mini-css-extract-plugin
export default {"container":"Location_container__dFPGC","toggleLocation":"Location_toggleLocation__jZEpt","toggleLocationLabel":"Location_toggleLocationLabel__tJGfM"};